import { render, staticRenderFns } from "./PageTitleDivider.vue?vue&type=template&id=0221dcb8&scoped=true&"
import script from "./PageTitleDivider.vue?vue&type=script&lang=js&"
export * from "./PageTitleDivider.vue?vue&type=script&lang=js&"
import style0 from "./PageTitleDivider.vue?vue&type=style&index=0&id=0221dcb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0221dcb8",
  null
  
)

export default component.exports